<template>
  <section>
    <b-card> Gz Kitap && Panel</b-card>
    <HomeChart v-if="$can('view', 'home-chart-stat')" />
    <HomeStoreSales v-if="$can('view', 'home-store-sales-stat')" />
    <HomeProductSales v-if="$can('view', 'home-product-sales-stat')" />
    <HomeBrandSales v-if="$can('view', 'home-brand-sales-stat')" />
    <HomeStats v-if="$can('view', 'home-stats-stat')" />
  </section>
</template>

<script>
import HomeStats from './home/HomeStats.vue'
import HomeChart from './home/HomeChart.vue'
import HomeProductSales from './home/HomeProductSales.vue'
import HomeBrandSales from './home/HomeBrandSales.vue'
import HomeStoreSales from './home/HomeStoreSales.vue'

export default {
  name: 'Home',
  components: { HomeStats, HomeChart, HomeProductSales, HomeBrandSales, HomeStoreSales },
  data: () => ({}),
  created() {
    this.$store.dispatch('question/getAll2')
    this.$store.dispatch('orderQuestion/getAll')
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
